var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemoer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1008 822",
    width: 1008,
    height: 822,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 690.9,
    y1: 523.2,
    x2: 721.1,
    y2: 553.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 399.2,
    cy: 756.9,
    r: 85.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 922.6,
    cy: 228.7,
    r: 85.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 210.2,
    y1: 626.2,
    x2: 180,
    y2: 656.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 80.8,
    cy: 435.4,
    r: 85.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 569.2,
    y1: 800,
    x2: 24.6,
    y2: 216,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d00f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d00f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae4ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae4ce6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 880.7,
    y1: 9.5,
    x2: 327.1,
    y2: 800,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9000ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9000ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e576fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e576fd"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}.b{fill:url(#g2)}.c{fill:url(#g3)}.d{fill:url(#g4)}.e{fill:url(#g5)}.f{fill:url(#g6)}.g{fill:url(#g7)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m952.8 259.1l30.2 30.5-523.4 528.3-30.2-30.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m399.2 843.1c-47.2 0-85.4-38.5-85.4-86.2 0-47.7 38.2-86.2 85.4-86.2 47.3 0 85.5 38.5 85.5 86.2 0 47.7-38.2 86.2-85.5 86.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m922.6 314.9c-47.3 0-85.4-38.6-85.4-86.2 0-47.7 38.1-86.3 85.4-86.3 47.2 0 85.4 38.6 85.4 86.3 0 47.6-38.2 86.2-85.4 86.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m369 787.4l-30.2 30.5-318.6-321.7 30.2-30.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m80.6 521.4c-47.3 0-85.5-38.5-85.5-86.2 0-47.7 38.2-86.2 85.5-86.2 47.2 0 85.4 38.5 85.4 86.2 0 47.7-38.2 86.2-85.4 86.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m20.2 435.2c-16.7-16.8-16.7-44.1 0-60.9l144.2-145.6c16.7-16.9 43.7-16.9 60.4 0l348.9 352.1c16.7 16.9 16.7 44.1 0 61l-144.3 145.6c-16.6 16.8-43.7 16.8-60.4 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m778.3 22.1c16.7-16.8 43.8-16.8 60.4 0l144.3 145.6c16.7 16.8 16.7 44.1 0 61l-553.6 558.7c-16.6 16.8-43.7 16.8-60.4 0l-144.2-145.6c-16.7-16.9-16.7-44.1 0-61z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoer);
export default __webpack_public_path__ + "static/media/memoer.69a0e2d66e4471ee077a677af82cb612.svg";
export { ForwardRef as ReactComponent };